export const DOMAIN_CONFIG = {
  // Your custom domain
  domain: 'pidating.pi',
  
  // API endpoints
  api: {
    base: 'https://api.pidating.pi',
    auth: 'https://auth.pidating.pi',
    payments: 'https://payments.pidating.pi'
  },
  
  // CDN and assets
  cdn: 'https://cdn.pidating.pi',
  
  // Email configuration
  email: {
    support: 'support@pidating.pi',
    privacy: 'privacy@pidating.pi',
    legal: 'legal@pidating.pi',
    noreply: 'noreply@pidating.pi'
  },
  
  // Social media and marketing
  social: {
    twitter: 'https://twitter.com/pidating',
    instagram: 'https://instagram.com/pidating',
    facebook: 'https://facebook.com/pidating'
  },
  
  // SEO and metadata
  seo: {
    title: 'πPi Dating - Pioneer Dating App',
    description: 'Find your perfect match with Pi Dating - the revolutionary dating app powered by Pi Network. Connect, chat, and find love in the Pi ecosystem.',
    keywords: 'pi dating, pi network dating, cryptocurrency dating, blockchain dating, pioneer dating',
    image: 'https://pidating.pi/og-image.png'
  }
};